

// import arrow from "../../images/"

function LatestStorie(){
    return (
        <div id="LatestStories">
            <h2>Latest Stories</h2> <hr className="line3"/>
            <br/>
           
            <div id="Flex-container">
                
                <div className="flex-child">
                    <h3>Catch waves with an adventure guide</h3>
                    <p>Gujarat is vastly underrated and it’s a mystery to us why the region isn’t more well-known as a tourist destination. It has a plethora of temples and palaces Gujarat is vastly underrated and it’s a mystery to us why the region isn’t more well-known as a tourist destination. It has a plethora of temples and palaces</p>
                    <p className="tech"><b>TECH</b>/ TODAY AT 11:54</p>
                </div>
                <div className="flex-child">
                    <h3>Catch waves with an adventure guide</h3>
                    <p>Gujarat is vastly underrated and it’s a mystery to us why the region isn’t more well-known as a tourist destination. It has a plethora of temples and palaces Gujarat is vastly underrated and it’s a mystery to us why the region isn’t more well-known as a tourist destination. It has a plethora of temples and palaces</p>
                    <p className="tech"><b>TECH</b>/ TODAY AT 11:54</p>
                </div>
                <div className="flex-child">
                    <h3>Catch waves with an adventure guide</h3>
                    <p>Gujarat is vastly underrated and it’s a mystery to us why the region isn’t more well-known as a tourist destination. It has a plethora of temples and palaces Gujarat is vastly underrated and it’s a mystery to us why the region isn’t more well-known as a tourist destination. It has a plethora of temples and palaces</p>
                    <p className="tech"><b>TECH</b>/ TODAY AT 11:54</p>
                </div>
               
            </div>
            <hr/>
               
                     <br/> <br/> <br/> <br/> <br/>
        </div>
    )
}

export default LatestStorie;